import { useState } from "react";
import { Button } from "react-bootstrap";
import ExpensesTable from "../../../components/Tables/ExpensesTable";
import { useExpense } from "../../../hooks/useExpense";
import FormDespesa from "./FormDespesa";

function todayInputDate() {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function Despesas() {
  const {
    expenses,
    isFetching,
    isLoading,
    createExpense,
    updateExpense,
    deleteExpense,
    isCreating,
    isUpdating,
    isDeleting,
  } = useExpense();

  const [showForm, setShowForm] = useState(false);
  const [editingExpense, setEditingExpense] = useState(null);

  const openCreate = () => {
    setEditingExpense(null);
    setShowForm(true);
  };

  const openEdit = (expense) => {
    setEditingExpense(expense);
    setShowForm(true);
  };

  const closeForm = () => {
    setShowForm(false);
    setEditingExpense(null);
  };

  const handleSubmit = async (payload) => {
    if (editingExpense?.id) {
      await updateExpense({ id: editingExpense.id, ...payload });
    } else {
      await createExpense(payload);
    }
    closeForm();
  };

  const handleDelete = async (expense) => {
    const confirmed = window.confirm(
      `Excluir a despesa "${expense.description || "sem descrição"}"?`
    );
    if (!confirmed) return;
    await deleteExpense(expense.id);
  };

  const handleMarkPaid = async (expense) => {
    await updateExpense({
      id: expense.id,
      confirmed_date: todayInputDate(),
    });
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
        <div>
          <h5 className="mb-0">Despesas</h5>
          <small className="text-muted">
            Cadastre despesas do escritório e marque como pagas para o fluxo de
            caixa.
          </small>
        </div>
        <Button
          type="button"
          className="btn-bg-primary text-dark borderColor"
          onClick={openCreate}
        >
          <i className="bi bi-plus-lg" /> Nova despesa
        </Button>
      </div>

      <ExpensesTable
        isFetching={isLoading || isFetching}
        expenses={expenses}
        onEdit={openEdit}
        onDelete={handleDelete}
        onMarkPaid={handleMarkPaid}
        isDeleting={isDeleting}
      />

      <FormDespesa
        show={showForm}
        onHide={closeForm}
        expense={editingExpense}
        onSubmit={handleSubmit}
        isSubmitting={isCreating || isUpdating}
      />
    </div>
  );
}

export default Despesas;
